// extracted by mini-css-extract-plugin
export default {"monacoEditorWrapper":"createScript_monacoEditorWrapper__rBJ2U"};